import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { KeyboardShortcutService } from './keyboard-shortcut.service';

import { FloatingWindowService } from '../floating-window/floating-window.service';

@Component({
  selector: 'app-keyboard-shortcut',
  imports: [],
  templateUrl: './keyboard-shortcut.component.html',
  styleUrl: './keyboard-shortcut.component.css',
})
export class KeyboardShortcutComponent implements OnInit, OnDestroy {
  @Input({ required: true }) keys!: string[];
  @Input({ required: true }) url!: string;

  private openFloating = () => {
    this.floatingWindow.open(this.url);
  };

  constructor(
    private shortcutService: KeyboardShortcutService,
    private floatingWindow: FloatingWindowService
  ) {}

  ngOnInit() {
    this.shortcutService.registerShortcut({
      keys: this.keys.map((k) => k.toLowerCase()),
      callback: this.openFloating,
    });
  }

  ngOnDestroy() {
    this.shortcutService.unregisterShortcut(this.openFloating);
  }
}
